 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import graphql from 'babel-plugin-relay/macro'
import React, {Suspense} from 'react'
import {useFragment} from 'react-relay'
import OrgAvatarInput from '../../../../components/OrgAvatarInput'
import useModal from '../../../../hooks/useModal'

import OrgBillingDangerZone from './OrgBillingDangerZone'
import defaultOrgAvatar from '../../../../styles/theme/images/avatar-organization.svg'
import EditableOrgName from '../../../../components/EditableOrgName'
import OrganizationDetails from '../Organization/OrganizationDetails'
import Avatar from '../../../../components/Avatar/Avatar'
import EditableAvatar from '../../../../components/EditableAvatar/EditableAvatar'





const OrgDetails = (props) => {
  const {organizationRef} = props
  const organization = useFragment(
    graphql`
      fragment OrgDetails_organization on Organization {
        ...OrgBillingDangerZone_organization
        ...EditableOrgName_organization
        orgId: id
        isBillingLeader
        createdAt
        picture
        billingTier
        tier
        name
      }
    `,
    organizationRef
  )
  const {
    orgId,
    createdAt,
    isBillingLeader,
    picture: orgAvatar,
    name,
    billingTier,
    tier
  } = organization
  const pictureOrDefault = _nullishCoalesce(orgAvatar, () => ( defaultOrgAvatar))
  const orgName = _nullishCoalesce(name, () => ( 'Unknown'))
  const {togglePortal, modalPortal} = useModal()

  return (
    React.createElement(Suspense, { fallback: '',}
      , React.createElement('div', { className: "mb-4 flex w-full items-center"   ,}
        , modalPortal(React.createElement(OrgAvatarInput, { picture: pictureOrDefault, orgId: orgId,} ))
        , isBillingLeader ? (
          React.createElement('div', { onClick: togglePortal, className: "mr-2",}
            , React.createElement(EditableAvatar, { hasPanel: true, picture: pictureOrDefault, size: 64, unstyled: true,} )
          )
        ) : (
          React.createElement('div', { className: "mr-4 w-16" ,}
            , React.createElement(Avatar, { picture: pictureOrDefault, size: 64, sansRadius: true, sansShadow: true,} )
          )
        )
        , React.createElement('div', { className: "text-gray-600 ml-2 flex flex-grow flex-col items-start"     ,}
          , isBillingLeader ? (
            React.createElement(EditableOrgName, { organization: organization,} )
          ) : (
            React.createElement('div', { className: "text-gray-700 text-2xl leading-9"  ,}, orgName)
          )
          , React.createElement(OrganizationDetails, { createdAt: createdAt, billingTier: billingTier, tier: tier,} )
        )
      )
      , React.createElement(OrgBillingDangerZone, { organization: organization, isWide: true,} )
    )
  )
}

export default OrgDetails
